import { Component, Input } from '@angular/core';

import { SignedVacations } from '@app/mot/schedule/shared/model/signed-vacations';
import { PdfService } from '@app/ptrab/services';
import { Logger } from '@app/services';
import { AnalyticsService } from '@app/services/analytics/analytics.service';
import { ActionsAnalytics, CategoriesAnalytics } from '@app/services/analytics/models/analytics.enum';

@Component({
  selector: 'app-mot-signed-vacations-list',
  templateUrl: './signed-vacations-list.component.html',
  styleUrls: ['./signed-vacations-list.component.scss']
})
export class SignedVacationsListComponent {
  @Input() signedVacations!: SignedVacations[];

  private logger = new Logger('SignedVacationsListComponent');

  constructor(private pdfService: PdfService, private analyticsService: AnalyticsService) {}

  downloadPdf(signedVacationsItem: SignedVacations) {
    this.analyticsService.sendEvent(CategoriesAnalytics.DOWNLOAD, {
      [ActionsAnalytics.DOWNLOAD]: ActionsAnalytics.HOLIDAYS,
      [ActionsAnalytics.TEXT]: `${signedVacationsItem.year}`
    });

    this.pdfService.fetchSignedVacationsPdf(signedVacationsItem.documentId).catch((err) => {
      this.logger.error(err);
    });
  }

  trackByItems(item: SignedVacations) {
    return item;
  }
}
